import React from "react";
// import { ModelTraining } from "@mui/icons-material";
import { EMISSION_FACTORS_REFERENCES, EMISSION_FACTORS_FILES } from "pages/authenticated/emission-factors";
import {
    EsgViewSummary,
    EsgDocumentUpload,
    EsgCheckMissing,
    ApprovalsIcon,
    EsgFilesIcon,
    EsgReferencesIcon,
    TargetIcon,
    InitiativesIcon,
} from "assets";
import { MenuOption } from "./types";

export const DOCUMENTS_MENU_OPTIONS: MenuOption[] = [
    {
        label: "Upload",
        to: "/documents",
        icon: <EsgDocumentUpload />,
        shortLabel: "U",
        key: 0,
    },
    {
        label: "Bill Entries",
        to: "/documents/summary",
        pattern: "/documents/summary/*",
        icon: <EsgViewSummary />,
        shortLabel: "V",
        key: 3,
    },
    {
        label: "Check Missing",
        to: "/documents/missing",
        icon: <EsgCheckMissing />,
        shortLabel: "C",
        key: 21,
    },
    {
        label: "Approvals",
        to: "/approvals",
        icon: <ApprovalsIcon />,
        shortLabel: "C",
        key: 5,
    },
];

export const TARGETS_MENU_OPTIONS: MenuOption[] = [
    {
        label: "Targets",
        to: "/targets",
        icon: <TargetIcon style={{ color: "#054254" }} />,
        shortLabel: "T",
        key: 0,
        configParameter: "target_setting_feature",
    },
    {
        label: "Initiatives Management",
        to: "/initiatives",
        icon: <InitiativesIcon />,
        shortLabel: "I",
        key: 1,
        configParameter: "initiative_managament_feature",
    },
    // {
    //     label: "Initiatives Modeling",
    //     to: "/initiatives-modeling",
    //     icon: <ModelTraining style={{ color: "#054254" }} />,
    //     shortLabel: "M",
    //     key: 2,
    //     configParameter: "initiative_modeling_feature",
    // },
];

export const RESOURCES_MENU_OPTIONS: MenuOption[] = [
    {
        label: "References",
        to: EMISSION_FACTORS_REFERENCES.ABSOLUTE_PATH,
        shortLabel: "U",
        icon: <EsgReferencesIcon />,
        key: 0,
    },
    {
        label: "Files",
        to: EMISSION_FACTORS_FILES.ABSOLUTE_PATH,
        shortLabel: "U",
        icon: <EsgFilesIcon />,
        key: 1,
    },
];

export const SIDEBAR_DIMENSIONS = {
    OPEN_WIDTH: '258px',
    CLOSED_WIDTH: '85px',
    ICON_MIN_WIDTH_OPEN: '25px',
    ICON_MIN_WIDTH_CLOSED: '56px',
    MARGIN_LEFT: '15px',
    TEXT_MARGIN_LEFT: '6px',
    MODAL_OFFSET: 20,
    ITEM_HEIGHT: '42px',
} as const;